import BaseController from "controllers/marketplace/base"

import React from 'react'
import ReactDOM from 'react-dom';

import Vehicle from 'components/vehicle/vehicle'

class Controller extends BaseController {
  call() {
    let vehicle_dom = document.getElementById('vehicle-component')
    let vehicle_props = gon.vehicle
    let bid_props = gon.bid
    ReactDOM.render( <Vehicle vehicle={{...vehicle_props}} bid={{...bid_props}}/>, vehicle_dom);
  }
};

export default Controller;
